import { AdvertPanel as AdvertPanelData } from 'services/freeform';

import styles from './advert-panel.module.scss';

type AdvertPanelProps = {
	data: AdvertPanelData;
};

export const AdvertPanel = ({ data }: AdvertPanelProps) => {
	const slots = [
		data.leftAdvertSlotId,
		data.middleAdvertSlotId,
		data.rightAdvertSlotId,
	].filter(Boolean) as string[];

	if (slots.length === 0 && !data.title) {
		return null;
	}

	return (
		<section
			className={`${styles.root} ${data.wrapperClassName || ''}`}
			aria-label={data.title || 'Advertisement panel'}
		>
			<div className={`container ${styles.container}`}>
				{data.title ? (
					<h3 className={`display-large bold ${styles.title}`}>
						{data.title}
					</h3>
				) : (
					<span className={styles.srOnly}>Advertisement</span>
				)}
				<ul className={styles.list}>
					{slots.map((slotId) => (
						<li key={slotId} className={styles.item}>
							<div
								className={styles.slot}
								data-ad-slot={slotId}
								aria-hidden="true"
							/>
						</li>
					))}
				</ul>
			</div>
		</section>
	);
};

export default AdvertPanel;
